import { Navigate, useLocation } from 'react-router-dom'
import { useAppSelector } from '../store/hooks'
import { UserRoles } from '@/models/login.model'
import { useEffect } from 'react'

type PrivateRouteProps = {
	children: React.ReactElement | null
	roles?: Array<UserRoles>
}

export function PrivateRoute({ children, roles }: PrivateRouteProps) {
	const {
		auth: { signed, user },
	} = useAppSelector((state) => state)

	const location = useLocation()

	const queryString = new URLSearchParams(location.search)

	const token = queryString.get('token')
	const code = queryString.get('code')
	const refreshToken = queryString.get('refreshToken')
	const email = queryString.get('email')

	let hasPermission = false

	useEffect(() => {
		if (signed && user) {
			// Função para separar o primeiro nome e o sobrenome
			const getFirstAndLastName = (fullName: string) => {
				const [firstName, ...lastName] = fullName.split(' ')
				return {
					firstName,
					lastName: lastName.join(' ') || firstName, // Caso não haja sobrenome, usa o primeiro nome para ambos
				}
			}

			const { firstName, lastName } = getFirstAndLastName(user.name)

			window.addEventListener('onEmbeddedMessagingReady', () => {
				window.embeddedservice_bootstrap.prechatAPI.setVisiblePrechatFields({
					_firstName: {
						value: firstName,
						isEditableByEndUser: true,
					},
					_lastName: {
						value: lastName,
						isEditableByEndUser: true,
					},
					_email: {
						value: user.email,
						isEditableByEndUser: true,
					},
				})
			})
		}
	}, [signed, user])

	if (roles && user) {
		const isSinglesCourse = user?.modo_curso_unico ? 'single_course' : undefined
		const isWhiteLabel = user?.white_label ? 'white_label' : undefined

		const isStudent =
			user?.modo_curso_unico || user?.white_label ? undefined : 'student'

		if (
			roles.includes(isSinglesCourse) ||
			roles.includes(isStudent) ||
			roles.includes(isWhiteLabel)
		) {
			hasPermission = true
		}
	}

	if (user?.modo_curso_unico && !hasPermission && location.pathname === '/') {
		if (token) {
			return <Navigate to={`/curso?token=${token}`} />
		} else if (code && refreshToken && email) {
			const queryParams = new URLSearchParams({
				code,
				refreshToken,
				email,
			}).toString()

			return <Navigate to={`/curso?${queryParams}`} />
		} else {
			return <Navigate to='/curso' />
		}
	}

	if (!hasPermission) {
		return <Navigate to='/entrar' />
	}

	return signed ? (
		children
	) : (
		<Navigate to='/entrar' state={{ redirect: location.pathname }} />
	)
}
